import { Link } from "react-router-dom";
import { useI18n } from "../../i18n/context.tsx";
import { SOCIAL_LINKS } from "../../utils/constants.ts";
import styles from "./Footer.module.css";

export function Footer() {
  const { t, localePath } = useI18n();

  return (
    <footer className={styles.footer}>
      <div className={styles.footerInner}>
        <div className={styles.footerLinks}>
          <Link to={localePath("/basketball/classic")} className={styles.footerLink}>
            {t.footer.basketballClassic}
          </Link>
          <Link to={localePath("/basketball/ai")} className={styles.footerLink}>
            {t.footer.basketballAi}
          </Link>
          <Link to={localePath("/tennis/classic")} className={styles.footerLink}>
            {t.footer.tennis}
          </Link>
          <Link to={localePath("/soccer/classic")} className={styles.footerLink}>
            {t.footer.soccer}
          </Link>
          <Link to={localePath("/golf/classic")} className={styles.footerLink}>
            {t.footer.golf}
          </Link>
          <a
            href={SOCIAL_LINKS.github}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.footerLink}
          >
            {t.footer.github}
          </a>
        </div>
        <div className={styles.socialLinks}>
          <a
            href={SOCIAL_LINKS.discord}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.socialLink}
          >
            Discord
          </a>
          <a
            href={SOCIAL_LINKS.x}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.socialLink}
          >
            X
          </a>
          <a
            href={SOCIAL_LINKS.tiktok}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.socialLink}
          >
            TikTok
          </a>
          <a
            href={SOCIAL_LINKS.threads}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.socialLink}
          >
            Threads
          </a>
        </div>
        <p className={styles.copyright}>{t.footer.copyright}</p>
      </div>
    </footer>
  );
}
